import React, { useEffect, useRef } from 'react';
import { getCursorFromDocumentIndex } from 'gatsby-source-prismic-graphql';
import styled from "@emotion/styled";
/*import colors from 'styles/colors';*/
import dimensions from 'styles/dimensions';
import { Inner, gridColumns } from 'styles/structure';
import { graphql } from 'gatsby';
import Layout from 'components/Layout';
import SEO from 'components/SEO';
import CardResource from 'components/CardResource';
import Button from 'components/_ui/Button';

const PressHeader = styled.header`
  padding: 6.4rem 0 4.8rem;
  text-align: center;

  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 8rem 0;
  }
`;

const PressList = styled.ul`
  
  li {
    & + * {
      margin-top: 4rem;
    }
  }
  
  & + * {
    margin-top: 5.6rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    flex-wrap: wrap;
  
    li {    
      & + * {
        margin-top: 0;
      }

      ${gridColumns('1/2', 2.4)};
      
      margin-right: 2.4rem;
      
      &:nth-of-type(n+3) {
        margin-top: 5.6rem;
      }
      
      &:nth-of-type(2n) {
        margin-right: 0;
      }
    }
  }
  
  @media(min-width: ${dimensions.desktopUp}px) {  
    li {    
      & + * {
        margin-top: 0;
      }
      
      &:first-of-type,
      &:nth-of-type(2) {
        ${gridColumns('1/2', 2.4)}
      }
      
      &:nth-of-type(n+3) {
        ${gridColumns('1/3', 2.4)}
        margin-top: 6.4rem;
      }
      
      &:nth-of-type(3n),
      &:nth-of-type(3n+1) {
        margin-right: 2.4rem;
      }
      
      &:nth-of-type(3n+2) {
        margin-right: 0;
      }
    }
  }
`;

const PressButton = styled.div`
  text-align: center;
  margin: 5.6rem 0 8rem;
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    margin: 8rem 0 10.4rem;
  }
`;

export default props => {
  const landing = props.data.prismic.topicByUID;

  const limit = 8;
  const didMountRef = useRef(false);
  const [page, setPage] = React.useState(-1);
  const [data, setData] = React.useState(props.data.prismic.allPosts);
  const [posts, setPosts] = React.useState(data.edges);

  const onLoadMore = () => {
    setPage(page + limit);
  };

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    props.prismic
      .load({ variables: { after: getCursorFromDocumentIndex(page) } })
      .then(res => {
        setData(res.data.allPosts);
        setPosts(p => p.concat(res.data.allPosts.edges));
      });
  }, [props, page]);

  return (
    <Layout>
      <SEO
        title={landing.social_title || 'Press Releases'}
        description={landing.social_description ? landing.social_description : null}
        image={landing.social_image ? landing.social_image.url : null}
      />

      <Inner>
        <PressHeader>
          <h2>Press Releases</h2>
        </PressHeader>

        <PressList>
          {posts.map(({ node, i }) => (
            <li key={i}>
              <CardResource
                title={node.title[0].text}
                uid={node._meta.uid}
                image={node.feature_image}
                author={node.author && node.author.name}
                promoteAuthor={node.promote_author}
              />
            </li>
          ))}
        </PressList>

        <PressButton>
          {data.pageInfo.hasNextPage && (
            <Button
              disabled={!data.pageInfo.hasNextPage}
              onClick={onLoadMore}
              className={!data.pageInfo.hasNextPage && 'is-disabled'}
            >
              <span>Load More</span>
            </Button>
          )}
        </PressButton>
      </Inner>
    </Layout>
  );
};

export const query = graphql`
  query getPressReleases($first: Int = 8, $after: String, $before: String) {
    prismic {
      topicByUID: topic(uid: "press-release", lang: "en-us") {
        name
        social_title
        social_description
        social_image
      }
      allPosts(first: $first, after: $after, before: $before, where: {topic: "XqtQ5BAAACQAdBgV"}, sortBy: publish_date_DESC) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            _meta {
              uid
            }
            title
            feature_image
            author {
              ... on PRISMIC_Person {
                name
              }
            }
            promote_author
            topic {
              ... on PRISMIC_Topic {
                name
              }
            }
          }
        }
      }
    }
  }
`;
